// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "link-23a2K";
var _3 = "link_noUnderline-uC0G0";
export { _1 as "__esModule", _2 as "link", _3 as "link_noUnderline" }
export default { "__esModule": _1, "link": _2, "link_noUnderline": _3 }
